export {User} from "./login";
export {PaperSet} from "./paperSet";
export {Paper} from "./paper";
export {PaperPart} from "./paperPart";
export {Question} from "./question";
export {Words} from "./words";
export {NavigationNumber} from "./navigationNumber";
export {PaperReport} from "./paperReport";
export {NewUser} from "./newUser";
export {Error} from "./error";
export {Count} from "./count";
export {Timer} from "./timer";
export {Entry} from "./entry";
export {StoredQuestion} from "./storedQuestion";
export { Attemp, NewAttempt } from './Attemp';
export { SubSubject } from './SubSubject';
export { CreditCard } from './CreditCard';
export { OnlinePaper } from './OnlinePaper';
export { Competition } from './competition';



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/model/index.ts